<!-- <div class="grid" *ngIf="displayItems">
    <div *ngFor="let item of galleryItems" class="grid-item">
      <div class="media">
        <img *ngIf="item.type === 'image'" [src]="item.url" [alt]="item.title" class="media-item" loading="lazy"/>
        <video *ngIf="item.type === 'video'" [src]="item.url" controls class="media-item"></video>
      </div>
      <p>{{ item.title }}</p>
    </div>
    
</div> -->

<div class="gallery-container">
  <div class="media-container">
    <ng-container *ngIf="currentItem">
      <img *ngIf="currentItem.type === 'image'" [src]="currentItem.url" [alt]="currentItem.title" class="media-item" loading="lazy"/>
      <video *ngIf="currentItem.type === 'video'" [src]="currentItem.url" controls class="media-item"></video>
      <app-embedded-video *ngIf="currentItem.type === 'youtube'" [videoId]="currentItem.url"></app-embedded-video>
      <app-embedded-podcast *ngIf="currentItem.type === 'podcast'" [spotifyId]="currentItem.url"></app-embedded-podcast>
      <p style="justify-items:center">{{ currentItem.title }}</p>
    </ng-container>
  </div>

  <div class="button-container">
    <button class="left-button" (click)="previous()">Previous</button>
    <p class="image-number">{{ currentIndex + 1 }}/{{ galleryItems.length }}</p>
    <button class="right-button" (click)="next()">Next</button>
  </div>
</div>